import { useChatbot } from 'src/common/ChatbotProvider'
import { cn } from 'src/utils/cn'
import PropTypes from 'prop-types'
import { useAnalytics } from 'src/common/analytics'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import ChatbotIconButton from '../../ChatbotIconButton'

const ChatbotButtonDesktop = ({ className }) => {
  const { openChatbot, isChatbotEnabled } = useChatbot()
  const { track } = useAnalytics()
  const router = useRouter()

  useEffect(() => {
    if (!isChatbotEnabled) return

    const hasInteracted =
      sessionStorage.getItem('isChatbotFirstInteraction') === 'false'

    if (!hasInteracted) {
      const data = {
        list_name: 'AIChatbot_Impression',
        event_type: 'track',
        event_name: 'AIChatbot_Impression',
        event_action: 'AIChatbot_Impression',
        nav_link_section: 'FDR Chatbot',
      }

      track(data)
      sessionStorage.setItem('isChatbotFirstInteraction', 'false')
    }
  }, [isChatbotEnabled, track, router.asPath])

  if (!isChatbotEnabled) {
    return null
  }

  return <ChatbotIconButton className={cn(className)} onClick={openChatbot} />
}

ChatbotButtonDesktop.propTypes = {
  className: PropTypes.string,
}

export { ChatbotButtonDesktop }
